import { render, staticRenderFns } from "./LifetimeSetter.vue?vue&type=template&id=69f43266&"
import script from "./LifetimeSetter.vue?vue&type=script&lang=js&"
export * from "./LifetimeSetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports